export default {
  "user": {
    "personal-center": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["マイページ"])},
    "control": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザーとアクセス制御"])},
    "setting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["プラットフォーム設定"])},
    "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログアウト"])},
    "subAccount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["サブアカウント"])}
  },
  "feedback": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["フィードバック"])},
  "help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ヘルプ"])},
  "messages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メッセージボックス"])},
  "count": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メッセージ数"])}
}